import { useMemo } from 'react'
import usePersonaPresenceRange from '../../../../../hooks/usePersonaPresenceRange'
import { publicPresenceState } from '../../../../../helpers/liveReportHelpers/publicPersonaState'
import usePublicPersona from './usePublicPersona'

// AI-CONTEXT: See docs/features/livereport-per-deelnemer.md (T6, T12)
// De ene plek waar de widget 'Aanwezigheid' van één deelnemer zijn regels
// vandaan haalt. Op de openbare link mag niemand Firestore lezen (ADR-022):
// daar komen dezelfde regels uit `personaData.presence` van
// getPublicLiveReport2, en filtert de periode hier. De widget blijft gelijk.

/**
 * @param {string|null} personaId - Deelnemer van het rapport (useWidgetPersona); `null` = geen
 * @param {Date|null} startDate - Begin van de periode; `null` = open
 * @param {Date|null} endDate - Einde van de periode; `null` = open
 * @param {{ enabled: boolean }} options - `false` met de module uit; op de link en in een template leest usePublicPersona (`isPublic`) de gegevens en blijft de live read uit
 * @returns {import('../../../../../hooks/usePersonaPresenceRange').PresenceRangeResult}
 */
const usePersonaPresenceData = (personaId, startDate, endDate, { enabled }) => {
    const { isPublic, personaData } = usePublicPersona()
    const startMillis = startDate ? startDate.getTime() : null
    const endMillis = endDate ? endDate.getTime() : null

    const live = usePersonaPresenceRange(startMillis, endMillis, {
        personaId,
        enabled: enabled && !isPublic && Boolean(personaId),
    })

    const fromLink = useMemo(
        () => (isPublic ? publicPresenceState(personaData, startMillis, endMillis) : null),
        [isPublic, personaData, startMillis, endMillis],
    )
    return fromLink || live
}

export default usePersonaPresenceData
